module.exports = __webpack_public_path__ + "img/map-tr.e86d6e79.svg";